import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://lunarambitions.com";

const LOCAL_BUSINESS_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "HealthAndBeautyBusiness",
  "@id": "https://lunarambitions.com/#business",
  name: "Lunar Ambitions",
  image: "https://lunarambitions.com/images/lunar-ambitions-logo.png",
  url: "https://lunarambitions.com/",
  telephone: "+1-407-538-9402",
  priceRange: "$75-$220",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Orlando",
    addressRegion: "FL",
    addressCountry: "US",
  },
  sameAs: [
    "https://www.instagram.com/lunarambitions/",
    "https://www.facebook.com/LunarAmbitions",
  ],
  description:
    "Lunar Ambitions is a licensed esthetician studio in Orlando, FL offering customized facials, nano needling, acne treatments, anti-aging skin care, and skin reset rituals.",
};

export const SEO = ({
  title,
  description,
  robots = null,
  skipCanonical = false,
  extraSchema = null,
}) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }

    let robotsTag = document.querySelector('meta[name="robots"]');
    if (robots) {
      if (!robotsTag) {
        robotsTag = document.createElement("meta");
        robotsTag.setAttribute("name", "robots");
        document.head.appendChild(robotsTag);
      }
      robotsTag.setAttribute("content", robots);
    } else if (robotsTag) {
      robotsTag.remove();
    }

    // extraSchema may be a single schema object or an array of schema
    // objects (e.g. a service page needs both Service + BreadcrumbList).
    // Each is synced to its own <script id="ld-json-extra-N"> tag, and any
    // stale tags left over from a page with more schemas are removed.
    const extraSchemas = extraSchema
      ? Array.isArray(extraSchema)
        ? extraSchema
        : [extraSchema]
      : [];
    function syncExtraSchemas(schemas) {
      schemas.forEach((s, i) => {
        let el = document.getElementById(`ld-json-extra-${i}`);
        if (!el) {
          el = document.createElement("script");
          el.type = "application/ld+json";
          el.id = `ld-json-extra-${i}`;
          document.head.appendChild(el);
        }
        el.textContent = JSON.stringify(s);
      });
      let i = schemas.length;
      let stale = document.getElementById(`ld-json-extra-${i}`);
      while (stale) {
        stale.remove();
        i += 1;
        stale = document.getElementById(`ld-json-extra-${i}`);
      }
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    let schema = document.getElementById("ld-json-localbusiness");
    if (skipCanonical) {
      if (canonical) canonical.remove();
      if (schema) schema.remove();
      syncExtraSchemas(extraSchemas);
      return;
    }

    let path = location.pathname;
    if (path !== "/" && path.endsWith("/")) {
      path = path.slice(0, -1);
    }
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${path}`);

    if (!schema) {
      schema = document.createElement("script");
      schema.type = "application/ld+json";
      schema.id = "ld-json-localbusiness";
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify(LOCAL_BUSINESS_SCHEMA);

    syncExtraSchemas(extraSchemas);
  }, [title, description, robots, skipCanonical, extraSchema, location.pathname]);
  return null;
};
